export default {
  "/v3/webinars/webinar/init-before-union": true,
  "/v1/marketing/app/wechat-oa/get-info": true,
  "/v3/webinars/watch/inline-init": true,
  "/v3/webinars/watch/init": true,
  "/v3/users/permission/get-config-list": true,
  "/v3/webinars/webinar-language/get-list": true,
  "/v3/interacts/union/common-config": true,
  "/v3/webinars/privilege/get-role-name": true,
  "/v3/interacts/union/player-config": true,
  "/v3/interacts/room/get-inav-tool-status": true,
  "/v1/marketing/app/wechat-oa/get-diverting-config": true,
  "/v3/users/user-consumer/info": true
}